import { Box, styled } from "@mui/material";

const InputContainerContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: 16,
  flexDirection: "row",
  justifyContent: "space-between",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));
export const InputContainer = (props: React.ComponentProps<typeof Box>) => (
  <InputContainerContainer
    display="flex"
    flexDirection="row"
    justifyContent="space-between"
    {...props}
  />
);
